import Login from "./components/Login";
import Navbar from "./components/Navbar";
import { Route, Routes } from "react-router-dom";
import Private from './Private'

function App() {
  return (
    <>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/navbar" element={<Private Component={Navbar} />} />
      </Routes>
    </>
  );
}

export default App;
